const transformData = [
    {
        name: 'Family & friends',
        key: 'question20',
    },
    {
        name: 'Business Angels',
        key: 'question25',
    },
    {
        name: 'Crowdfunding',
        key: 'question30',
    },
    {
        name: 'Incubators and Accelerators',
        key: 'question36',
    },
    {
        name: 'NGO’s loans',
        key: 'question41',
    },
    {
        name: 'NGO’s grants',
        key: 'question46',
    },
    {
        name: 'Public subsidies (e.g. tax credits)',
        key: 'question51',
    },
    {
        name: 'Public grants',
        key: 'question56',
    },
    {
        name: 'Venture capital',
        key: 'question61',
    },
    {
        name: 'Microfinance',
        key: 'question66',
    },
    {
        name: 'Financial institutions (banks)',
        key: 'question71',
    },
    {
        name: 'Other',
        key: 'question76',
    },
];

const series = [
    {
        name: '0 - 5 %',
        value: 'SKILLS_DWT_5',
    },
    {
        name: '6 - 25%',
        value: 'SKILLS_DWT_25',
    },
    {
        name: '26 - 50%',
        value: 'SKILLS_DWT_50',
    },
    {
        name: '51 - 75%',
        value: 'SKILLS_DWT_75',
    },
    {
        name: '76 - 100%',
        value: 'SKILLS_DWT_100',
    }
]

/**
 * Survey: PROJECT- FINAL IMPACT
 * Question: In your estimation, how much your participation in the program contributed to these results?
 * 
 * == final
 * question20
 * question25
 * question30
 * question36
 * question41
 * question46
 * question51
 * question56
 * question61
 * question66
 * question71
 * question76
 * 
 * @param props 
 */
export const accelerationProgramContributionToAccessFundsChartCalculation = (props: any) => {
    const calc = (value: string) => transformData.map(({name, key}: any) => ({
        name,
        y: props.finalSubmissions.filter((submission: any) => submission[key] === value).length
    }));
        
    return {
        chart: {
            type: 'column',
        },
        title: {
            text: 'KPI: E4I Acceleration Program contribution to access funds',
            align: 'left',
        },
        xAxis: {
            categories: transformData.map((el: any) => el.name),
        },
        plotOptions: {
            column: {
                stacking: 'percent',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.0f}%'
                }
            }
        },
        series: series.map(({value, name, color}: any) => ({
            type: 'column',
            name,
            data: calc(value),
            color,
        }))
    } as Highcharts.Options;
}